import React from 'react';
import EmptyData from 'components/Messages/EmptyData/EmptyData';
import { TableColumnInterface } from 'components/Table/table.types';
import OverviewTable from 'components/Table/Table';
import { IconBox } from 'components/StyledComponents/IconBox';
import { useTagGroupsContext } from 'pages/TagGroups/tagGroups.context';
import CreateTagGroup from 'pages/TagGroups/CreateTagGroup';
import { TagGroup } from '@restore/services-lib';
import UpdateTagGroup from 'pages/TagGroups/UpdateTagGroup';
import ArchiveTagGroup from 'pages/TagGroups/ArchiveTagGroup';
import RestoreTagGroup from 'pages/TagGroups/RestoreTagGroup';
import { Tag } from 'components/Tag/Tag';
import TagTableCellContainer from 'components/Tag/TagHelpers/TagTableCellContainer';

const TagGroupsTable = (): JSX.Element => {
  const { tagGroups } = useTagGroupsContext();

  const tableCols: TableColumnInterface<TagGroup>[] = [
    { label: 'ID', value: (tagGroup) => tagGroup.id },
    {
      label: 'Name',
      value: (tagGroup) => tagGroup.name,
      sortBy: 'name',
    },
    {
      label: 'Tags',
      value: (tagGroup) => (
        <TagTableCellContainer>
          {tagGroup.tags.map((tag) => (
            <Tag key={tag.id} color={tag.displayColour} text={tag.name} />
          ))}
        </TagTableCellContainer>
      ),
    },
    {
      label: '',
      align: 'right',
      value: (tagGroup) => (
        <IconBox>
          <UpdateTagGroup tagGroup={tagGroup} />
          {tagGroup.archived ? (
            <RestoreTagGroup tagGroup={tagGroup} />
          ) : (
            <ArchiveTagGroup tagGroup={tagGroup} />
          )}
        </IconBox>
      ),
    },
  ];

  return (
    <OverviewTable
      data={tagGroups}
      columns={tableCols}
      tableTitle='Tag Groups'
      tableActions={<CreateTagGroup />}
      noDataMessageOverride={<EmptyData dataType='tag group' action={<CreateTagGroup />} />}
    />
  );
};

export default TagGroupsTable;
